import { AdProduceComponent } from './components/ad/ad-produce/ad-produce.component';
import { AdComponent } from './components/ad/ad.component';
import { BudgetComponent } from './components/budget/budget.component';
import { AudienceComponent } from './components/audience/audience.component';
import { CampaignDetailsComponent } from './components/campaign-details/campaign-details.component';
import { AppCommonModule } from '../../../common/common.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignEditComponent } from './components/campaign-edit/campaign-edit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PaymentService } from '../../../services/payment.service';
import { CampaignSummaryComponent } from './components/campaign-summary/campaign-summary.component';
import { CampaignAdapter } from '../../../../adapters/campaign-adapter';
import { CreativeAdapter } from 'src/adapters/creative-adapter';
import { CampaignReviewComponent } from './components/campaign-review/campaign-review.component';
import { ValidatorAdapter } from 'src/adapters/validator-adapter';
import { BudgetingService } from 'src/app/services/budgeting.service';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { CampaignService } from './services/campaign.service';
import { DiscountCodeComponent } from './components/discount-code/discount-code.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

const components = [
  CampaignEditComponent,
  CampaignDetailsComponent,
  AudienceComponent,
  BudgetComponent,
  AdComponent,
  AdProduceComponent,
  CampaignSummaryComponent,
  CampaignReviewComponent,
  DiscountCodeComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    AppCommonModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot()
  ],
  exports: [CampaignEditComponent],
  providers: [
    CampaignAdapter,
    CreativeAdapter,
    PaymentService,
    ValidatorAdapter,
    BudgetingService,
    CampaignService
  ]
})
export class CampaignEditModule { }
